import App_pc from './App_pc';
import App_m from './App_m';

const ua = navigator.userAgent;
const ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
  isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
  isAndroid = ua.match(/(Android)\s+([\d.]+)/),
  isMobile = isIphone || isAndroid;

// export default isMobile ? App_m : App_pc;
export default App_pc;